export class TransactionTotalsEntity {
  succeededTransactionsNumber: number
  pendingTransactionsNumber: number
  failedTransactionsNumber: number
  disputedTransactionsNumber: number
  refundedTransactionsNumber: number
  totalTransactionsNumber: number

  private constructor(transactionTotals: {
    succeededTransactionsNumber: number
    pendingTransactionsNumber: number
    failedTransactionsNumber: number
    disputedTransactionsNumber: number
    refundedTransactionsNumber: number
  }) {
    this.succeededTransactionsNumber = transactionTotals.succeededTransactionsNumber
    this.pendingTransactionsNumber = transactionTotals.pendingTransactionsNumber
    this.failedTransactionsNumber = transactionTotals.failedTransactionsNumber
    this.disputedTransactionsNumber = transactionTotals.disputedTransactionsNumber
    this.refundedTransactionsNumber = transactionTotals.refundedTransactionsNumber
    this.totalTransactionsNumber =
      transactionTotals.succeededTransactionsNumber +
      transactionTotals.pendingTransactionsNumber +
      transactionTotals.failedTransactionsNumber +
      transactionTotals.disputedTransactionsNumber +
      transactionTotals.refundedTransactionsNumber
  }

  static fromDto(dto: {
    succeededTransactionsNumber: number
    pendingTransactionsNumber: number
    failedTransactionsNumber: number
    disputedTransactionsNumber: number
    refundedTransactionsNumber: number
  }): TransactionTotalsEntity {
    return new TransactionTotalsEntity(dto)
  }
}
